module.exports = __webpack_public_path__ + "img/w4_03.d06f1837.jpg";